<template>
  <v-container :fluid="true" v-if="isWordListReady">
    <v-card :flat="true" v-if="!editPage && !confirmPage">
      <v-card-title class="mb-3 text-h5 font-weight-bold">{{
        wordList.lbl_tmp_member_list
      }}</v-card-title>
      <v-card-text>
        <v-card :flat="true">
          <div
            v-if="$vuetify.display.xs"
            class="d-flex justify-end br_b_1 br_t_1 py-2 mb-5"
          >
            <v-btn variant="text" color="black" @click="onClickListSearch" class="px-1">
              絞り込み検索<v-icon>mdi-text-search</v-icon>
            </v-btn>
            <v-btn variant="text" color="black" @click="onClickListSetting" class="pl-3 pr-0">
              設定<v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </div>
          <!-- 検索条件入力 { -->
          <v-expansion-panels v-else :flat="true" v-model="panel" multiple class="br_1">
            <v-expansion-panel>
              <v-expansion-panel-title
                class="py-0 font-weight-bold bk_gray_3"
                >{{ wordList.lbl_search }}</v-expansion-panel-title
              >
              <v-expansion-panel-text class="bk_gray_3">
                <v-divider />
                <Form v-slot="{ meta }">
                  <form>
                    <v-card class="bk_gray_3" flat>
                      <v-card-text class="pt-9">
                        <v-row>
                          <!-- お名前(漢字・かな) -->
                          <v-col cols="12" sm="6" md="4" class="py-0">
                            <Field
                              v-slot="{ componentField, errors }"
                              v-model="searchConditionName"
                              :name="wordList.lbl_name_kanji_kana"
                              rules="max:100"
                            >
                              <v-text-field
                                v-bind="componentField"
                                :label="wordList.lbl_name_kanji_kana"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                              ></v-text-field>
                            </Field>
                          </v-col>
                          <!-- 電話番号 -->
                          <v-col cols="12" sm="6" md="4" class="py-0">
                            <Field
                              v-slot="{ componentField, errors }"
                              v-model="searchConditionPhone"
                              :name="wordList.lbl_tel"
                              rules="numeric|length:4"
                            >
                              <v-text-field
                                v-bind="componentField"
                                :label="wordList.lbl_tel"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                              ></v-text-field>
                            </Field>
                          </v-col>
                          <!-- 郵便番号 -->
                          <v-col cols="12" sm="6" md="4" class="py-0">
                            <Field
                              v-slot="{ componentField, errors }"
                              v-model="searchConditionZipCode"
                              :name="wordList.lbl_zipcode"
                              rules="numeric|length:7"
                            >
                              <v-text-field
                                v-bind="componentField"
                                :label="wordList.lbl_zipcode"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                              ></v-text-field>
                            </Field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          variant="flat"
                          color="primary"
                          class="px-16 mt-6"
                          :disabled="!meta.valid"
                          @click="onClickSearch"
                          ><v-icon>mdi-magnify</v-icon
                          >{{ wordList.lbl_search }}</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </form>
                </Form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <div
            v-if="$vuetify.display.xs"
            class="color_red"
            style="font-size: 12px"
          >
            仮会員登録完了から60分が経過しますと、一覧から自動的に削除されます。<br />
            対象の仮会員情報がない場合は、お手数ですが再度ご登録ください。
          </div>
          <!-- 検索条件入力 } -->
          <!-- 一覧表示  { -->
          <v-card :flat="true" width="100%">
            <v-data-table-server
              item-value="tmpMemberId"
              :page="listOptions.page"
              :items-per-page="listOptions.itemsPerPage"
              @update:options="onUpdateOptions"
              :items="listDataArray"
              :items-length="listDataTotalCount"
              :loading="listLoading"
              :no-data-text="wordList.lbl_no_data_text"
              :headers="filteredTableHeaders()"
              hide-default-footer
              :mobile="isXs"
              :hide-default-header="isXs"
            >
              <template v-slot:top>
                <div class="d-flex justify-space-between mt-9 mb-5">
                  <div class="d-flex align-center flex-wrap">
                    <span class="pl-3">全 {{ listDataTotalCount }} 件 </span
                    ><span class="pl-1"> {{ displayPagingRangeText }} </span>
                    <v-pagination
                      v-model="listOptions.page"
                      :length="pageCount"
                      :total-visible="7"
                      variant="elevated"
                      density="comfortable"
                    >
                    </v-pagination>
                  </div>
                  <div
                    v-if="!$vuetify.display.xs"
                    class="color_red d-flex align-center"
                  >
                    仮会員登録完了から60分が経過しますと、一覧から自動的に削除されます。<br />
                    対象の仮会員情報がない場合は、お手数ですが再度ご登録ください。
                  </div>
                  <div v-if="!$vuetify.display.xs">
                    <v-btn variant="text" color="black" @click="onClickListSetting" class="px-2">
                      設定<v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <!-- PC -->
                <div v-if="!$vuetify.display.xs">
                  <!-- 配達依頼ボタン -->
                  <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        @click="
                          onClickDeliveryRequestByTmpMember(
                            item.tmpMemberId,
                            item.is_deliverable
                          )
                        "
                        variant="outlined"
                        icon
                        color="primary"
                        class="my-2 ml-2"
                        size="x-small"
                      >
                        <v-icon>mdi-truck</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ wordList.btn_delivery_regits_member }}</span>
                  </v-tooltip>

                  <!-- メンバー登録ボタン -->
                  <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        @click="onClickMemberRegister(item.tmpMemberId)"
                        variant="outlined"
                        icon
                        color="primary"
                        class="my-2 ml-2"
                        size="x-small"
                      >
                        <v-icon>mdi-account-plus-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ wordList.btn_regits_member }}</span>
                  </v-tooltip>
                </div>

                <!-- モバイル -->
                <div v-else class="d-flex justify-end flex-wrap mb-3">
                  <v-btn
                    @click="
                      onClickDeliveryRequestByTmpMember(
                        item.tmpMemberId,
                        item.is_deliverable
                      )
                    "
                    variant="outlined"
                    color="primary"
                    class="my-2 ml-2 mr-0"
                  >
                    <v-icon>mdi-truck</v-icon>
                    {{ wordList.btn_delivery_regits_member }}
                  </v-btn>

                  <v-btn
                    @click="onClickMemberRegister(item.tmpMemberId)"
                    variant="outlined"
                    color="primary"
                    class="my-2 ml-2 mr-0"
                  >
                    <v-icon>mdi-account-plus-outline</v-icon>
                    {{ wordList.btn_regits_member }}
                  </v-btn>
                </div>
              </template>
            </v-data-table-server>
          </v-card>
        </v-card>
      </v-card-text>
    </v-card>
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
    <AlertDialog
      v-model="notdeliverableerrdialog"
      :title="wordList.lbl_err_dialog_title"
      message="配達可能エリア外のため配送依頼を登録できません。&#10;配達可能エリアをご確認ください。"
      type="error"
    />
    <!-- 一覧設定ダイアログ { -->
    <v-dialog
      persistent
      v-model="displayListSettingDialog"
      content-class="dialog_width_2"
      height="100%"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center pb-0">
          <div>一覧設定</div>
          <v-btn
            variant="text"
            icon="mdi-close"
            @click="displayListSettingDialog = false"
          ></v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <v-container class="pt-2">
            <draggable v-model="tableHeadersSetting" item-key="id" tag="div">
              <template #item="{ element }">
                <v-row
                  class="mt-0 mb-0 pt-0 pb-0"
                  :class="{ br_b_1: $vuetify.display.xs }"
                >
                  <v-col
                    cols="12"
                    class="my-2 pt-0 pb-0 d-flex justify-space-between align-center"
                    :class="{ 'px-0': $vuetify.display.xs }"
                  >
                    <div :class="{ caption: $vuetify.display.xs }">
                      <v-icon>mdi-drag</v-icon>
                      {{ element.settingText }}
                    </div>
                    <div
                      class="d-flex pt-0"
                      :class="{ 'mt-1': $vuetify.display.xs }"
                    >
                      <div class="d-flex align-center">
                        <v-switch
                          v-model="element.display"
                          color="primary"
                          class="mt-0"
                          hide-details
                        ></v-switch>
                        <div class="setting_line"></div>
                      </div>
                      <v-radio-group
                        inline
                        v-model="element.order"
                        class="mt-0 flex-shrink-0"
                        hide-details
                      >
                        <v-radio
                          true-icon="mdi-arrow-up-drop-circle"
                          false-icon="mdi-arrow-up-drop-circle-outline"
                          value="asc"
                          :disabled="element.orderDisabled"
                          class="mr-1"
                        ></v-radio>
                        <v-radio
                          true-icon="mdi-arrow-down-drop-circle"
                          false-icon="mdi-arrow-down-drop-circle-outline"
                          value="desc"
                          :disabled="element.orderDisabled"
                          class="mr-0"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>
              </template>
            </draggable>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-5 pb-7">
          <v-btn
            class="width_30per"
            variant="outlined"
            @click="onClickListSettingCancel"
            >キャンセル</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="width_30per"
            variant="outlined"
            @click="onClickListSettingReset"
            >リセット</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="width_30per"
            variant="flat"
            color="primary"
            @click="onClickListSettingOk"
            >設定</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- } 一覧設定ダイアログ -->
    <!-- スマホ検索ダイアログ { -->
    <v-dialog
      v-model="displayListSearchDialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <Form v-slot="{ meta }">
        <form>
          <v-card :flat="true">
            <v-card-title class="px-0 py-0">
              <v-toolbar color="primary">
                <v-btn icon @click="displayListSearchDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>絞り込み検索</v-toolbar-title>
                <v-spacer></v-spacer> </v-toolbar
            ></v-card-title>
            <v-card-text
              class="py-0 overflow-auto"
              style="height: calc(100vh - 133px)"
            >
              <v-row>
                <!-- お名前(漢字・かな) -->
                <v-col cols="12" sm="6" md="4" class="mt-10 py-0">
                  <Field
                    v-slot="{ componentField, errors }"
                    v-model="searchConditionName"
                    :name="wordList.lbl_name_kanji_kana"
                    rules="max:100"
                  >
                    <v-text-field
                      v-bind="componentField"
                      :label="wordList.lbl_name_kanji_kana"
                      bg-color="#fff"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
                <!-- 電話番号 -->
                <v-col cols="12" sm="6" md="4" class="py-0">
                  <Field
                    v-slot="{ componentField, errors }"
                    v-model="searchConditionPhone"
                    :name="wordList.lbl_tel"
                    rules="numeric|length:4"
                  >
                    <v-text-field
                      v-bind="componentField"
                      :label="wordList.lbl_tel"
                      bg-color="#fff"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
                <!-- 郵便番号 -->
                <v-col cols="12" sm="6" md="4" class="py-0">
                  <Field
                    v-slot="{ componentField, errors }"
                    v-model="searchConditionZipCode"
                    :name="wordList.lbl_zipcode"
                    rules="numeric|length:7"
                  >
                    <v-text-field
                      v-bind="componentField"
                      :label="wordList.lbl_zipcode"
                      bg-color="#fff"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                variant="flat"
                color="primary"
                class="px-16 my-3"
                :disabled="!meta.valid"
                @click="onClickSearch"
                ><v-icon>mdi-magnify</v-icon>{{ wordList.lbl_search }}</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </form>
      </Form>
    </v-dialog>
    <!-- } スマホ検索ダイアログ -->
  </v-container>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import { max, numeric, length } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import { useDisplay } from "vuetify";
import draggable from "vuedraggable";
import AlertDialog from "@/components/AlertDialog.vue";
import { TMP_MEMBER_LIST_FILE_NAME } from "./constants";
import { useTmpMemberUiState } from "./composables/useTmpMemberUiState";
import { useTmpMemberSearchForm } from "./composables/useTmpMemberSearchForm";
import { useTmpMemberTable } from "./composables/useTmpMemberTable";
import { useTmpMemberTableSettings } from "./composables/useTmpMemberTableSettings";
import { useTmpMemberActions } from "./composables/useTmpMemberActions";
import { useTmpMemberInit } from "./composables/useTmpMemberInit";

// vee-validate rules
defineRule("max", max);
defineRule("numeric", numeric);
defineRule("length", length);
configure({
  generateMessage: localize({ ja }),
});
setLocale('ja');

const { xs } = useDisplay();
const isXs = computed(() => xs.value);

// ============================
// state
// ============================

// -------------------------------
// 画面UI状態
// -------------------------------
const {
  errdialog,
  notdeliverableerrdialog,
  errMessage,
  editPage,
  confirmPage,
  panel,
  processFlag,
  overlay,
  displayListSettingDialog,
  displayListSearchDialog,
  onClickListSearch,
  openListPage,
  openEditPage,
  openConfirmPage,
} = useTmpMemberUiState();

// -------------------------------
// 検索フォーム
// -------------------------------
const {
  searchConditionName,
  searchConditionPhone,
  searchConditionZipCode,
} = useTmpMemberSearchForm();

// -------------------------------
// 一覧取得・ページング
// -------------------------------
const {
  defaultTableHeaders,
  tableHeaders,
  listLoading,
  listOptions,
  listDataArray,
  listDataTotalCount,
  displayPagingRangeText,
  pageCount,
  filteredTableHeaders,
  initTableHeaders,
  searchQuery,
  onClickSearch,
  onUpdateOptions,
} = useTmpMemberTable({
  searchConditionName,
  searchConditionPhone,
  searchConditionZipCode,
  errdialog,
  errMessage,
  displayListSearchDialog,
});

// -------------------------------
// 一覧設定ダイアログ
// -------------------------------
const {
  tableHeadersSetting,
  onClickListSetting,
  onClickListSettingCancel,
  onClickListSettingReset,
  onClickListSettingOk,
} = useTmpMemberTableSettings({
  pageKey: TMP_MEMBER_LIST_FILE_NAME,
  defaultTableHeaders,
  tableHeaders,
  displayListSettingDialog,
});

// -------------------------------
// 行アクション
// -------------------------------
const {
  getDeliveryAvailable,
  onClickDeliveryRequestByTmpMember,
  onClickMemberRegister,
  onClickEdit,
  onClickConfirmUpdateOk,
} = useTmpMemberActions({
  notdeliverableerrdialog,
  errdialog,
  errMessage,
  editPage,
  overlay,
  openListPage,
  searchQuery,
});

// -------------------------------
// 住所関連 State（初期化で使用）
// -------------------------------
const prefSelectValue = ref("");
const cityBlockList = ref<any>(null);
const originalAddress = ref("");

// -------------------------------
// 初期化ロジック
// -------------------------------
const {
  wordList,
  isWordListReady,
  runInitialLoad,
} = useTmpMemberInit({
  initTableHeaders,
  getDeliveryAvailable,
  errdialog,
  errMessage,
  prefSelectValue,
  cityBlockList,
  originalAddress,
});

// -------------------------------
// マウント時処理
// -------------------------------
onMounted(async (): Promise<void> => {
  await runInitialLoad();
});
</script>

<style scoped>
/* 一覧設定ダイアログ: v-radio-groupのデフォルトflex-directionを上書きして横並びにする */
:deep(.v-radio-group > .v-input__control) {
  flex-direction: row;
}
</style>
